/**
 * Notifications API client — backs the bell dropdown in the admin topbar.
 *
 * REST Endpoints:
 *   GET  /bot/api/notifications?limit=20&unread_only=false  → { items: [...] }
 *   GET  /bot/api/notifications/unread_count                → { count: N }
 *   POST /bot/api/notifications/{id}/read                   → { status: 'success' }
 *   POST /bot/api/notifications/read_all                    → { status, updated }
 */

import { getToken } from './auth';
import { getBaseUrl } from './utils';

function authHeaders() {
  const token = getToken();
  return token
    ? { Authorization: `Bearer ${token}`, Accept: 'application/json' }
    : { Accept: 'application/json' };
}

function url(path) {
  const base = getBaseUrl();
  return `${base}/bot/api/notifications${path}`.replace(/([^:]\/)\/+/g, '$1');
}

export async function listNotifications({ limit = 20, unreadOnly = false } = {}) {
  try {
    const res = await fetch(
      url(`?limit=${limit}&unread_only=${unreadOnly ? 'true' : 'false'}`),
      { headers: authHeaders() }
    );
    if (!res.ok) return [];
    const data = await res.json().catch(() => ({}));
    return Array.isArray(data.items) ? data.items : [];
  } catch {
    return [];
  }
}

export async function getUnreadCount() {
  try {
    const res = await fetch(url('/unread_count'), { headers: authHeaders() });
    if (!res.ok) return 0;
    const data = await res.json().catch(() => ({}));
    return data.count || 0;
  } catch {
    return 0;
  }
}

export async function markRead(id) {
  try {
    await fetch(url(`/${id}/read`), { method: 'POST', headers: authHeaders() });
  } catch {
    /* swallow — UI optimistically updates */
  }
}

export async function markAllRead() {
  try {
    await fetch(url('/read_all'), { method: 'POST', headers: authHeaders() });
  } catch {
    /* swallow */
  }
}
